import Crud from '../views/Familia/Crud'
import Entity from '../views/Familia/Add'

let routes = {
    path: '/familias',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/familias/add',
            name: 'NewFamilia',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Família',
                breadcrumb: [
                    {
                        text: 'Famílias',
                        to: '/familias',
                        active: false,
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/familias/edit/:id?',
            name: 'EditFamilia',
            component: Entity,
            meta: {
                pageTitle: 'Editar Família',
                breadcrumb: [
                    {
                        text: 'Famílias',
                        to: '/familias',
                        active: false,
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/familias',
            name: 'list-familias',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Famílias',
                breadcrumb: [
                    {
                        text: 'Famílias',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
